import { useContext } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers";
import { Box, Grid, FormControl, MenuItem, Select, InputLabel, TextField, Autocomplete } from "@mui/material";
import { camelToNormal } from "../../utils/function";
import { RegistrantFilterContext } from "../../context/RegistrantFilterContext";
import { ratings, realtorTypes, sources, statuses, leaseTypes } from "../../utils/constant";
import { selectUsers } from "../../features/projectSetting/projectSettingSlice";
import { capitalizeFirstLetterEachWord, capitalizeFirstLetter } from "../../utils/function";
import { selectProjectTags } from "../../features/projectSetting/projectSettingSlice";

const RegistrantFilter = () => {
  const {
    realtorTypeFilter,
    setRealtorTypeFilter,
    leaseTypeFilter,
    setLeaseTypeFilter,
    statusFilter,
    setStatusFilter,
    ratingFilter,
    setRatingFilter,
    onlineSalesRepFilter,
    setOnlineSalesRepFilter,
    salesRepFilter,
    setSalesRepFilter,
    sourceFilter,
    setSourceFilter,
    emailUnsubscribedFilter,
    setEmailUnsubscribedFilter,
    textUnsubscribedFilter,
    setTextUnsubscribedFilter,
    connectedFilter,
    setConnectedFilter,
    startDateFilter,
    setStartDateFilter,
    endDateFilter,
    setEndDateFilter,
    cameInStartDateFilter,
    setCameInStartDateFilter,
    cameInEndDateFilter,
    setCameInEndDateFilter,
    tags,
    setTags,
  } = useContext(RegistrantFilterContext);

  const users = useSelector(selectUsers);
  const projectTags = useSelector(selectProjectTags);
  const leaseTypeOptions = ["any", ...leaseTypes];
  const realtorTypeOptions = ["any", ...realtorTypes];
  const statusOptions = ["any", ...statuses];
  const ratingOptions = ["any", ...ratings];
  const salesRepOptions = ["any", "none", ...users.slice()];
  const onlineSalesRepOptions = ["any", "none", ...users.slice()];
  const sourceOptions = ["any", ...sources];
  const subscribedOptions = ["any", true, false];
  const connectedOptions = ["any", true, false];
  const { listid } = useParams();

  return (
    <Box sx={{ mb: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} lg={4}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label="Registrant Created Date Start"
              value={startDateFilter ? new Date(startDateFilter!) : null}
              onChange={(newValue) => {
                setStartDateFilter(newValue);
              }}
              maxDate={endDateFilter ? new Date(endDateFilter) : new Date('2095-01-01')}
              sx={{ width: '100%'}}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label="Registrant Created Date End"
              value={endDateFilter ? new Date(endDateFilter!) : null}
              onChange={(newValue) => {
                setEndDateFilter(newValue);
              }}
              minDate={startDateFilter ? new Date(startDateFilter) : new Date('2000-01-01')}
              sx={{ width: '100%'}}
            />
          </LocalizationProvider>
        </Grid>
        {listid && listid === "came-ins" ? (
          <>
            <Grid item xs={12} sm={6} lg={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  label="Came in Date Start"
                  value={cameInStartDateFilter ? new Date(cameInStartDateFilter!) : null}
                  onChange={(newValue) => {
                    setCameInStartDateFilter(newValue);
                  }}
                  maxDate={cameInEndDateFilter ? new Date(cameInEndDateFilter) : new Date('2095-01-01')}
                  sx={{ width: '100%'}}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  label="Came In Date End"
                  value={cameInEndDateFilter ? new Date(cameInEndDateFilter) : null}
                  onChange={(newValue) => {
                    setCameInEndDateFilter(newValue);
                  }}
                  minDate={cameInStartDateFilter ? new Date(cameInStartDateFilter) : new Date('2000-01-01')}
                  sx={{ width: '100%'}}
                />
              </LocalizationProvider>
            </Grid>
          </>
        ) : null}
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Realtor Type</InputLabel>
            <Select
              value={realtorTypeFilter}
              label="Realtor Type"
              onChange={(e) => (setRealtorTypeFilter ? setRealtorTypeFilter(e.target.value) : null)}
            >
              {realtorTypeOptions.map((realtorTypeOption: string, index: number) => {
                return (
                  <MenuItem key={index} value={realtorTypeOption}>
                    {camelToNormal(realtorTypeOption)}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Lease Type</InputLabel>
            <Select
              value={leaseTypeFilter}
              label="Realtor Type"
              onChange={(e) => (setLeaseTypeFilter ? setLeaseTypeFilter(e.target.value) : null)}
            >
              {leaseTypeOptions.map((leaseType: string, index: number) => {
                return (
                  <MenuItem key={index} value={leaseType}>
                    {camelToNormal(leaseType)}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select value={statusFilter} label="Status" onChange={(e) => (setStatusFilter ? setStatusFilter(e.target.value) : null)}>
              {statusOptions.map((statusOption: string, index: number) => {
                return (
                  <MenuItem key={index} value={statusOption}>
                    {camelToNormal(statusOption)}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Rating</InputLabel>
            <Select value={ratingFilter} label="Rating" onChange={(e) => (setRatingFilter ? setRatingFilter(e.target.value) : null)}>
              {ratingOptions.map((ratingOption: string, index: number) => {
                return (
                  <MenuItem key={index} value={ratingOption}>
                    {capitalizeFirstLetter(ratingOption)}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Sales Rep</InputLabel>
            <Select
              value={salesRepFilter}
              label="Sales Rep"
              onChange={(e) => (setSalesRepFilter ? setSalesRepFilter(e.target.value) : null)}
            >
              {salesRepOptions.map((salesRepOption: any, index: number) => {
                return (
                  <MenuItem key={index} value={salesRepOption}>
                    {salesRepOption === "any" && "Any"}
                    {salesRepOption === "none" && "None"}
                    {salesRepOption?._id && `${salesRepOption?.firstName} ${salesRepOption?.lastName}`}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Online Sales Rep</InputLabel>
            <Select
              value={onlineSalesRepFilter}
              label="Online Sales Rep"
              onChange={(e) => (setOnlineSalesRepFilter ? setOnlineSalesRepFilter(e.target.value) : null)}
            >
              {onlineSalesRepOptions.map((salesRepOption: any, index: number) => {
                return (
                  <MenuItem key={index} value={salesRepOption}>
                    {salesRepOption === "any" && "Any"}
                    {salesRepOption === "none" && "None"}
                    {salesRepOption?._id && `${salesRepOption?.firstName} ${salesRepOption?.lastName}`}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Source</InputLabel>
            <Select value={sourceFilter} label="Source" onChange={(e) => (setSourceFilter ? setSourceFilter(e.target.value) : null)}>
              {sourceOptions.map((sourceOption: string, index: number) => {
                return (
                  <MenuItem key={index} value={sourceOption}>
                    {capitalizeFirstLetterEachWord(sourceOption)}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Email Subscribed</InputLabel>
            <Select
              value={emailUnsubscribedFilter}
              label="Email Subscribed"
              onChange={(e) => (setEmailUnsubscribedFilter ? setEmailUnsubscribedFilter(e.target.value) : null)}
            >
              {subscribedOptions.map((subscribedOption: any, index: number) => {
                return (
                  <MenuItem key={index} value={subscribedOption}>
                    {subscribedOption === "any" && "Any"}
                    {subscribedOption === true && "Yes"}
                    {subscribedOption === false && "No"}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <InputLabel>SMS Subscribed</InputLabel>
            <Select
              value={textUnsubscribedFilter}
              label="SMS Subscribed"
              onChange={(e) => (setTextUnsubscribedFilter ? setTextUnsubscribedFilter(e.target.value) : null)}
            >
              {subscribedOptions.map((subscribedOption: any, index: number) => {
                return (
                  <MenuItem key={index} value={subscribedOption}>
                    {subscribedOption === "any" && "Any"}
                    {subscribedOption === true && "Yes"}
                    {subscribedOption === false && "No"}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Connected</InputLabel>
            <Select
              value={connectedFilter}
              label="Connected"
              onChange={(e) => (setConnectedFilter ? setConnectedFilter(e.target.value) : null)}
            >
              {connectedOptions.map((connectedOption: any, index: number) => {
                return (
                  <MenuItem key={index} value={connectedOption}>
                    {connectedOption === "any" && "Any"}
                    {connectedOption === true && "Yes"}
                    {connectedOption === false && "No"}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <Autocomplete
              multiple
              id="tags-standard"
              options={projectTags}
              freeSolo={false}
              getOptionLabel={(option: any) => option}
              isOptionEqualToValue={(option, value) => option === value}
              value={tags}
              onChange={(e, value) => setTags(value)}
              renderInput={(params) => <TextField {...params} variant="outlined" label="Tags" />}
            />
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RegistrantFilter;
